<template>
  <v-flex xs12 sm8 md4>
    <v-card class="elevation-12">

      <v-toolbar
        dark
        color="primary"
      >
        <v-toolbar-title>Register</v-toolbar-title>
      </v-toolbar>

      <v-card-text>
        <v-form>
          <v-text-field
            prepend-icon="person"
            name="login"
            label="Set email"
            type="text"
            v-model="email"
            :error-messages="errors.email"
          >
          </v-text-field>
          <v-text-field
            prepend-icon="lock"
            name="password"
            label="Set password"
            type="password"
            v-model="password"
            :error-messages="errors.password"
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <a
          @click="login()"
        >
          Already have an account? Login
        </a>
        <v-btn
          color="primary"
          @click="register()"
          :loading="loading"
        >
          Register
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
  import mixinsPages from '@/mixins/pages'
  import * as auth from '@/services/auth'

  export default {
    mixins: [mixinsPages],
    data () {
      return {
        email: '',
        password: '',
        loading: false,
        errors: {
          email: [],
          password: []
        }
      }
    },
    methods: {
      async register () {
        try {
          this.loading = true
          const data = await this.$axios.post('register', {
            email: this.email,
            password: this.password
          })
          this.$router.push({name: 'login', query: {active: 'info'}})
        } catch (error) {
          this.loading = false
          this.errors = error.response.data
        }
      },
      login () {
        this.$router.push({name: 'login'})
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/register.vue